module.exports = __webpack_public_path__ + "assets/img/blingBoxBtn.734b32c6.png";